import(/* webpackMode: "eager", webpackExports: ["Web3Lazy"] */ "/home/vwsec/Projects/quizonchain/components/web3-lazy.tsx");
